module.exports = __webpack_public_path__ + "9b471a4b532fc5086ef67289efcc1efb.png";